import styled from '@emotion/styled'
import { stylesIf } from 'utils/styles'
import { Paragraph } from 'components/patterns/Typography'

export const HistoryListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`
export const HistoryListItemCol = styled.div((props) => {
  const { alignRight } = props
  return `
    display: flex;
    flex-direction: column;
    margin-right: 15px;
    ${stylesIf(alignRight, `margin-left: auto;`)}
  `
})

export const TimeStamp = styled(Paragraph)`
  margin-bottom: 3px;
`
